module.exports = __webpack_public_path__ + "img/孔庙和国子监博物馆.b1b79498.png";